import React, { Component} from 'react';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import i18n from 'i18next';
import Cookies from "js-cookie";
import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import { connect } from 'react-redux';
import {bindActionCreators} from "redux";
import { Button } from "reactstrap";

import { setConfigHoursCalendar } from "../../../calendar/components/sidebar/sidebar.actions";
import { SLOT_DURATION_ES, SLOT_DURATION_EN, SLOT_INTERVAL } from "../../../constants";

class ConfigurationHours extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slotDuration: '',
      slotInterval: '',
      fields: {text: 'text', value: 'value'}
    };
    this.inputSlotDuration = React.createRef(null);
    this.inputSlotInterval = React.createRef(null);
    this.position = { X: 'Right', Y: 'Top' };
    this.toasts = [
      { content: i18n.t("schedule.toast-process-complete"), cssClass: 'e-toast-black', icon: '' }
    ];
  }

  toastCusAnimation = {
    hide: { duration: '1' },
    show: { duration: '200' }
  };

  componentDidMount() {
    const { calendarTimeScale } = this.props;
    this.inputSlotDuration.current.value = calendarTimeScale.interval;
    this.inputSlotInterval.current.value = calendarTimeScale.slotCount;
    this.setState({
      slotDuration: calendarTimeScale.interval,
      slotInterval: calendarTimeScale.slotCount
    });
    const imapConfigHoursCalendar = Cookies.get(`Lefebvre.ImapConfigHoursCalendar`);
    if (imapConfigHoursCalendar) {
      const configHoursSplit = imapConfigHoursCalendar.split('|');
      this.inputSlotDuration.current.value = parseInt(configHoursSplit[1], 10);
      this.inputSlotInterval.current.value = parseInt(configHoursSplit[2], 10);
      this.setState({
        slotDuration: parseInt(configHoursSplit[1], 10),
        slotInterval: parseInt(configHoursSplit[2], 10)
      });
    }
  }

  updateConfigHours = () => {
    const { calendarTimeScale } = this.props;
    const { slotDuration, slotInterval } = this.state;
    const newCalendarTimeScale = {
      ...calendarTimeScale,
      interval: slotDuration,
      slotCount: slotInterval
    };
    const cookieData = `${true}|${slotDuration}|${slotInterval}`;
    if (window.REACT_APP_ENVIRONMENT === 'QA') {
      Cookies.set(`Lefebvre.ImapConfigHoursCalendar`, cookieData, {
        domain: 'localhost',
        expires: 365
      });
    } else {
      Cookies.set(`Lefebvre.ImapConfigHoursCalendar`, cookieData, {
        domain: 'lefebvre.es',
        sameSite: 'None',
        secure: true,
        expires: 365
      });
    }
    this.props.setConfigHoursCalendar(newCalendarTimeScale);
    this.props.close(true);
  }

  render() {
    const { slotDuration, slotInterval, fields } = this.state;
    const slotDurationOptions = i18n.language === 'en' ? SLOT_DURATION_EN : SLOT_DURATION_ES;
    return (
      <div className="configuration-hours-wrapper mt-4 form-group">
        <div>
          <label className="inter-regular-16 label-field-text">
            {i18n.t("calendar.slot_duration")}
          </label>
          <DropDownListComponent
            ref={this.inputSlotDuration}
            dataSource={slotDurationOptions}
            value={slotDuration}
            fields={fields}
            change={e => {
              this.setState({slotDuration: e.value});
            }}
            popupHeight="100px"
            className="field-input"
          />
          <span className="input-divider" />
        </div>
        <div className="mt-4">
          <label className="inter-regular-16 label-field-text">
            {i18n.t("calendar.slot_interval")}
          </label>
          <DropDownListComponent
            ref={this.inputSlotInterval}
            dataSource={SLOT_INTERVAL}
            value={slotInterval}
            fields={fields}
            change={e => {
              this.setState({slotInterval: e.value});
            }}
            popupHeight="100px"
            className="field-input"
          />
          <span className="input-divider" />
        </div>
        <div className="e-footer-content">
          <div className="mt-5 mb-4 btn-action-container">
            <Button
              className="btn-outline-primary inter-bold-16"
              title={i18n.t("general.cancel")}
              color="secondary"
              onClick={() => this.props.close(false)}
            >
              {i18n.t("general.cancel")}
            </Button>
            <Button
              className="ml-2 inter-bold-16"
              title={i18n.t("general.save")}
              color="primary"
              onClick={() => this.updateConfigHours()}
            >
              {i18n.t("general.save")}
            </Button>
          </div>
        </div>
        <ToastComponent
          ref={toast => {
            this.toastObj = toast;
          }}
          id="toast_pos"
          position={this.position}
          target={this.target}
          animation={this.toastCusAnimation}
          timeOut={7000}
          showCloseButton
        ></ToastComponent>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  calendarTimeScale: state.calendarsResult.calendarTimeScale
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      setConfigHoursCalendar
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((ConfigurationHours));
